export default __webpack_public_path__ + "static/palettte1-ea0c132eb865ff9c5d480aa9b96fabe8.jpg";